import React from 'react';
import { ArrowLeft, ArrowRight, LogOut } from 'lucide-react';
import { Button } from '../ui/button';
import { DOOR_DESIGNER_STAGES } from './stages';

export const StageNavBar: React.FC<{
  stageIndex: number;
  isLastStage: boolean;
  onExit: () => void;
  onBack: () => void;
  onContinue: () => void;
}> = ({ stageIndex, isLastStage, onExit, onBack, onContinue }) => {
  const nextStage = DOOR_DESIGNER_STAGES[stageIndex + 1];
  const nextLabel = nextStage ? `Next step: ${nextStage.stepperLabel}` : 'Request quote';

  return (
    <footer className="flex shrink-0 items-center justify-between gap-3 border-t border-border bg-card px-4 py-3">
      {stageIndex === 0 ? (
        <Button type="button" variant="outline" className="gap-2 uppercase tracking-wide" onClick={onExit}>
          <LogOut className="h-4 w-4" />
          Exit Designer
        </Button>
      ) : (
        <Button type="button" variant="outline" className="gap-2 uppercase tracking-wide" onClick={onBack}>
          <ArrowLeft className="h-4 w-4" />
          Previous step
        </Button>
      )}
      <Button
        type="button"
        className="gap-2 uppercase tracking-wide"
        disabled={isLastStage}
        title={isLastStage ? 'Quote handoff is not wired yet' : undefined}
        onClick={onContinue}
      >
        {nextLabel}
        {isLastStage ? null : <ArrowRight className="h-4 w-4" />}
      </Button>
    </footer>
  );
};
